import { postRequest } from '../libs/AxiosService.util';

export async function serviceFetchUserDeals(params) {
    return await postRequest('jobs', params);
}

export async function serviceGetUserDealsDetail(params) {
    return await postRequest('job/detail', params);
}

export async function serviceGetUserDealsInterest(params) {
    return await postRequest('jobs/interest', params);
}

export async function serviceChangeDealCategory(params) {
    return await postRequest('job/change/category', params);
}

export async function serviceDownloadUserDealsExcel(params) {
    return await postRequest('job/download', params);
}

export async function serviceUnpublishUserDeals(params) {
    return await postRequest('job/unpublish', params);
}

export async function serviceGetUserDealsOrderDetails(params) {
    return await postRequest('user/deals/details', params);
}
